import config from '../config';

export const getFirstAvailableHub = () => {
  return config.HUBS[0];
};

export const getHubByKey = (hubKey) => {
  return config.HUBS.find((hub) => hub.KEY === hubKey);
};

export const getHubOptions = () => {
  return config.HUBS.map((hub) => ({ ...hub, label: hub.LABEL, value: hub.KEY }));
};

export const getAvailableRoutingHubs = () => {
  return config.HUBS.map((hub) => hub.ROUTING_HUB);
};

//Get hub by code('hub') prop that is stored in DB in users collection
export const getHubByUserCode = (code) => {
  return config.HUBS.find((hub) => hub.CODE === code);
};

export const getHubByRoutingHub = (routingHub) => {
  return config.HUBS.find((hub) => hub.ROUTING_HUB === routingHub);
};

//get marketing url for specific page that is defined in config file for specific hub
export const getMarketingUrlByHubKey = (hubKey, configPageKey) => {
  const { MARKETING_SITE_URI = '', MARKETING_SITE = {} } = getHubByKey(hubKey) || {};
  return MARKETING_SITE_URI + (MARKETING_SITE[configPageKey] || '');
};

//get marketing url for specific page that is defined in config file for specific routing hub value
export const getMarketingUrlByRoutingHub = (routingHub, configPageKey) => {
  const { MARKETING_SITE_URI = '', MARKETING_SITE = {} } = getHubByRoutingHub(routingHub) || {};
  return MARKETING_SITE_URI + (MARKETING_SITE[configPageKey] || '');
};
